import Stack from '@mui/material/Stack'
import { CampaignSubmit } from '../../CampaignSubmit'
import { isSkipFieldName } from '../common/SkipButton'
import { ViewProps } from '../types'
import { RenderField } from './RenderField'
import { ReviewSkipButton } from './ReviewSkipButton'

export function DefaultView(props: ViewProps) {
  const { fields, submitForm, isSubmitting } = props

  /**
   * Check if skipField (noPublicConsent or noVideoRecord) exists
   * and if does, filter out from list and render skip button below submit
   */

  const skipFields = fields.filter(field => isSkipFieldName(field.name))
  const regularFields = fields.filter(field => !isSkipFieldName(field.name))

  return (
    <Stack gap={3}>
      {regularFields.map((field, index) => (
        <RenderField key={`${index}-${field.name}`} field={field} {...props} />
      ))}
      <CampaignSubmit onClick={submitForm} disabled={isSubmitting} />
      {skipFields.length ? <ReviewSkipButton {...props} /> : null}
    </Stack>
  )
}
